<template>
  <div v-if="hasAdditionalData">
    <v-divider class="my-8" />

    <h2 class="mb-5">
      {{ $t('appointment.additionalData.modalTitle') }}
    </h2>

    <div v-for="item in additionalData" :key="item.id" class="mb-5">
      <h6 class="text-uppercase grey--text">
        {{ item.title }}
      </h6>
      <p class="body-2">
        {{ item.value }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppointmentAdditionalInfo',

  props: {
    appointment: {
      type: Object,
      required: true,
    },
  },

  computed: {
    additionalData() {
      return this.appointment?.additional_data
    },

    hasAdditionalData() {
      return this.additionalData?.length > 0
    },
  },
}
</script>
